// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ja-0";
export var animationContainer = "_ja-1";
export var itemPrice = "_ja-a";
export var itemizedContent = "_ja-9";
export var itemizedHeader = "_ja-7";
export var itemizedRow = "_ja-8";
export var itemizedSection = "_ja-6";
export var modalContent = "_ja-2";
export var orderName = "_ja-3";
export var refundOption = "_ja-4";
export var refundOptionsContainer = "_ja-5";
export var shippingLabel = "_ja-b";
export var totalRow = "_ja-c";